import { type RovoContentBridgeAPIShape } from '@atlassian/rovo-content-bridge-api/dist/types/rovo-bridge-api-interface';
import {
  AifcExperienceTrackingCommand,
  ROVO_CHAT_CLIENT_ID,
  type AifcExperienceTrackingCommandProperties,
} from '@atlassian/rovo-content-bridge-api-commands';

import { isRovoPreview } from '@canvas/frame-api/host-api/host-frame-context';
import { client } from '@canvas/rovo-content-bridge-api';

const getSenderId = (contentId: string) => {
  return client(`confluence-database-${contentId}`);
};

type AIFCExperienceName = 'aiMateAifcAllDataHandled' | 'aiMateAifcInitialDataReceived';

type SendDatabaseAIFCExperienceTrackingParams =
  | {
      status: 'fail';
      error: Error;
      bridge: RovoContentBridgeAPIShape;
      experienceName: AIFCExperienceName;
      contentId: string;
    }
  | {
      status: 'success';
      bridge: RovoContentBridgeAPIShape;
      experienceName: AIFCExperienceName;
      contentId: string;
    };

export const sendDatabaseAIFCExperienceTrackingToParent = (
  params: SendDatabaseAIFCExperienceTrackingParams
) => {
  const { status, bridge, experienceName, contentId } = params;
  const baseProps = {
    status,
    actionType: 'database' as const,
    actionId: contentId,
    senderId: getSenderId(contentId),
    receiverId: ROVO_CHAT_CLIENT_ID,
    experienceName,
    contentContext: isRovoPreview() ? ('staging-area' as const) : ('global' as const),
  };

  const commandProps: AifcExperienceTrackingCommandProperties =
    status === 'fail'
      ? { ...baseProps, status, error: params.error.message }
      : { ...baseProps, status };

  bridge.send(AifcExperienceTrackingCommand, commandProps);
};
